import { getAuthAxiosBackend } from "../../helpers/axios"

class ActivityServices{

    get(id){
        return getAuthAxiosBackend().get('activities/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('activities', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('activities/' + id)
    }
}

export default new ActivityServices()